import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import ChatbotInterface from './components/ChatbotInterface';
import ChatbotInterfaceTest from './components/ChatbotInterfaceTest';
import LogsViewer from './components/Dashboard/LogsViewer';  // Import the LogsViewer component
import './App.css';



function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="/chatbot" element={<ChatbotInterface />} />
          <Route path="/chatbot-test" element={<ChatbotInterfaceTest />} />
          <Route  // Add the logs route
            path="/logs"
            element={
              <PrivateRoute>
                <LogsViewer />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/chatbot" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;